<template>
  <section class="modal adduser" @click="changeState({element: 'invite', val: false})">
    <div class="modal-wrap">
    <div class="modal-block" @click.prevent.stop>
      <!-- Поиск -->
        <div class="timeline-string">
      <div class="search">
        <div class="search-input">
          <img class="search__icon" src="@/assets/images/icons/icon_search.svg">
          <input type="search" placeholder="Ищи ветра в поле" v-model="search" @keyup.enter="searchByTitle">
        </div>
      </div>

    <!-- Фильтры -->
      <div class="timeline-buttons">
        <div class="map-button map-button_rainbow" @click="changeState({element: 'sports'})" v-if="!friends">
          <p>Категории</p>
        </div>
        <div class="button" @click="myFriends()" :class="{active: friends}">Мои друзья</div>
      </div>
      </div>
      <Sports :sports="getActiveSports" v-if="!friends"/>
      <div class="modal-body" v-if="users && users.users.length > 0">

        <div class="people" @click="addUser(user)" v-for="user in users.users" :key="user.id" :class="{cover: user.cover ? 'cover' : '', active: hasInvited(user), invited: alreadyInvited(user), joined: alreadyJoined(user) || isAuthor(user)} " :style="{backgroundImage: 'url('+ user.cover +')'}">
            <div class="chouse-check">
              <img src="@/assets/images/icon_check-user.svg" width="16px">
            </div>
            <div class="already-joined" v-if="isAuthor(user)">Создатель ивента</div>
            <div class="already-invited" v-if="alreadyInvited(user)">Уже приглашен</div>
            <div class="already-joined" v-if="alreadyJoined(user)">Уже учавствует</div>
            <div class="people-avatar" :style="{backgroundImage: 'url('+ user.avatar +')', backgroundPosition: user.avatar_position}">
                <div class="people-rate" v-if="user.rate" :title="user.rate.title" :class="user.rate.color">
                    <img :src="require(`@/assets/images/defaults/icon_${user.rate.image}.png`)">
                </div>
            </div>
            <p class="people__name">{{ user.firstname + ' ' + user.lastname}}</p>
            <p class="people__status">{{ user.shortdesc }}</p>
            <div class="people-category" v-if="user.sports">
                <div v-for="cat in shortSports(user)" :key="cat.id" class="people-category__item" :class="cat.color">{{cat.ru}}</div>
                <div class="people-category__item dark" v-if="user.sports.length > 5">и еще {{user.sports.length - 5}}</div>
            </div>
        </div>
      </div>
      <div class="modal-body" v-else>
        <p class="modal-nothing">Ничего не найдено 💩</p>
      </div>
    </div>
    <div class="chousen-counter" v-if="invited.length > 0" @click="sendInvite()">
      <p>Пригласить {{invited.length}} людей</p>
    </div>
    </div>
  </section>
</template>
<script>
import Sports from '@/components/Filters/Sports'

export default {
  name: "ModalInvite",
  data: () => {
    return {
      search: null,
      users: null,
      invited: [],
      friends: false
    };
  },
  components: {
    Sports
  },
  computed: {
      getActiveSports () {
        return this.$store.getters.getActiveSports
      },
      getActiveEvent () {
        return this.$store.getters.getActiveEvent
      },
      getUser () {
        return this.$store.getters.getAuthUser
      }
      
  },
  methods: {
    async loadData() {
      let type = this.friends ? 'friends' : '';
      let data = {sports: this.getActiveSports, search: this.search, type: type, user: this.getUser.id, page: 0, token: localStorage.getItem('token')};
      this.users = this.friends ?  await this.$store.dispatch('getFriends', data) : await this.$store.dispatch('getUsers', data);
    },
    shortSports(user) {
      return user.sports.slice(0, 5)
    },
    myFriends () {
      this.friends = !this.friends
      this.loadData()
    },
    changeState (element) {
        this.$store.dispatch('changeState', element)
    },
    hasInvited (user){
      return this.invited.find(item => user.id === item.id) ? true : false
    },
    isAuthor(user) {
      return Number(this.getActiveEvent.author_id) == Number(user.id)
    },
    alreadyInvited (user){
      return this.getActiveEvent.invites ? this.getActiveEvent.invites.find(item => user.id === item.id) ? true : false : false
    },
    alreadyJoined (user){
      return this.getActiveEvent.users.find(item => user.id === item.id) ? true : false
    },
    addUser (user) {
      let finded = this.invited.find(item => user.id === item.id);
      finded ? this.invited.splice(this.invited.indexOf(finded), 1) : this.invited.push(user)
    },
    async sendInvite() {
      let event = {
        id: this.getActiveEvent.id,
        name: this.getActiveEvent.title,
        link: 'http://wiildwood.online' + this.$route.fullPath,
        image: this.getActiveEvent.cover
      };
      this.$store.dispatch('sendInvite', {users: this.invited, event})
      this.$store.dispatch('addNotification', {message: "Вы пригласили новых людей!"})
      this.changeState({element: 'invite', val: false})
    },
    searchByTitle () {
      this.search && this.search.length > 2 ? '' : this.search = null
      this.loadData()
    }
  },
  watch: {
    getActiveSports () {
      this.loadData('sports')
    }
  },
  mounted () {
    this.loadData()
  }
};
</script>
<style lang="stylus" scoped>
.profile
    width 100%
    min-height 100vh
    padding 0 30px
    overflow-y auto
    padding-bottom 60px
    +to-width(640px)
        padding 0
        padding-bottom 50px
    +to-width(540px)
        padding-bottom 100px

    &-more
        position absolute
        right 10px
        top 15px
        padding 10px
        cursor pointer
        transform rotate(90deg)

    &-pins
        +to-width(540px)
            margin-left -30px
            margin-right -30px
        .pins-wrap
            padding 0
    &-info
        display none

    &-stats
        width 100%
        background-color #c4eaed
        height 130px
        border-radius 0 0 20px 20px
        +to-width(1100px)
            overflow-x auto
            height 160px
            padding-bottom 50px

        +to-width(640px)
            padding-top 60px
            height 200px

        +to-width(460px)
            width auto
            margin-right -15px
            margin-left -15px
            
        ::-webkit-scrollbar
            width 0px!important
            height 0px!important
            display none

        ::-webkit-scrollbar-track
            background white

        ::-webkit-scrollbar-thumb
            background #f1f1f1
            border-radius 50px

        ::-webkit-scrollbar-thumb:hover
            background #555
            border-radius 50px

        .profile-wrap
            display flex
            align-items center
            height 100%
    
    .wrap
        max-width 1150px

    &-wrap
        position relative
        padding 0 30px
        // width 100%
        margin-left 380px
        max-width 1020px
        +to-width(1200px)
            margin-left 344px
        +to-width(1100px)
            margin-left 0px
            center()
        +to-width(640px)
            justify-content flex-start
            padding-right 30px
        
    
    &-card
        position fixed
        left 30px
        top -105px
        pointer-events all
        +to-width(1100px)
            left inherit
            top -50px
    
    &-body
        position relative
        width 100%
        padding-left 414px
        +to-width(1200px)
            padding-left 374px
        +to-width(1100px)
            padding-left 0
        +to-width(640px)
            padding 0 15px
        +to-width(360px)
            padding 0
    
    &-fixed
        width 100%
        z-index 3
        position fixed
        pointer-events none
        +to-width(1100px)
            position relative
            center()

    &-friends
        display flex
        margin-top 40px
        &__all
            height 60px
            padding 20px
            background-color var(--main)
            font-size 13px
            font-weight 500
            color white
            margin-left -15px
            border 2px solid white
            border-radius 50px
            center()
            +to-width(360px)
                // height 50px
                padding 15px

    &-friend
        width 60px
        height 60px
        border 2px solid white
        border-radius 50%
        // background-color var(--main)
        background-color white
        margin-left -15px
        background-size cover
        &:first-child
            margin-left 0
            display block !important
        +to-width(600px)
            display none
            &:nth-child(2)
                display block
            &:nth-child(3)
                display block
            &:nth-child(5)
                display block
    
    &-about
        margin-top 30px
        font-size 16px
        line-height 30px
        &_textarea
            width 100%
            margin-top 30px
            font-size 16px
            line-height 30px
            border none
    
    &-photos
        display flex
        margin-top 30px
        position relative
        // &:after
        //     content ''
        //     position absolute
        //     right 0px
        //     top 0
        //     bottom 0
        //     width 100px
        //     background linear-gradient(to right, transparent, white)

        .slick-slide
            width 150px
            min-width 150px
            margin 0 10px

        &__add
            cursor pointer
            height 200px
            width 150px
            min-width 150px
            border-radius 10px
            background-color #f0f0f0
            display flex !important
            center()
            color white
            position relative
            img
                width 50px

        &__delete
            center()
            background-color white
            width 30px
            height 30px
            position absolute
            right 5px
            top 5px
            border-radius 8px
            opacity 0
            cursor pointer
            color var(--main)
            t()
            +to-width(920px)
                opacity 1
            &:hover
                background-color crimson
                color white

        &__item
            cursor pointer
            height 200px
            width 150px
            overflow hidden
            min-width 150px
            border-radius 10px
            background-color var(--main)
            background-size cover
            position relative
            &:last-child
                margin-right 0
        
            &:hover
                .profile-photos__delete
                    opacity 1
        &:hover
            .profile-title__icon
                opacity 0.7
        
    &-events
        margin-top 50px
        &:hover
            .profile-title__icon
                opacity 0.7
        
        .nothing
            font-size 14px
            width 100%
            height 160px
            background #f6f6f6
            background var(--blocks)
            border-radius 20px
            margin-top 10px
        

        +to-width(640px)
            margin-left -30px
            margin-right -30px
            padding-left 30px
    
    &-event
        margin-right 10px
        max-width 250px
        width 250px
        min-width 250px
        cursor pointer
        &:last-child
            margin-right 0
        
        &__label
            // color white
            color #767676
            font-size 20px
            margin auto
        &__image
            width 100%
            height 150px
            // background-color #1f1e2b
            background-color #f0f0f0
            border-radius 10px
            background-size cover
            background-position center
            center()
    
    &-slider
        display flex
        margin-top 10px

        .slick-slide
            margin 0 10px
    
    &-title
        display flex
        justify-content space-between
        align-items flex-end
        padding-bottom 14px

        h3
            font-weight 500
            color #a4d0d4
        
        &-wrap
            display flex
            align-items center
        
            
        &__icon
            margin-left 15px
            width 21px
            height 21px
            border-radius 50%
            background-color #a4d0d4
            color white
            font-size 13px
            cursor pointer
            position relative
            opacity 0
            center()
            t()
            svg
                width: 14px
            +to-width(768px)
                opacity 1
    
    &-tags
        margin-top 5px
        display flex

        p
            color $blue
            font-size 12px
            font-weight 500
            margin 5px 0
            margin-right 5px
            display none
            &:first-child
                display block
    
    &__text
        font-size 13px
        line-height 20px
        font-weight 500
    
    
    &-switcher
        font-size 13px
        font-weight 500
        color #d0d0d0
        span
            margin-left 10px
            color #d0d0d0
            cursor pointer
            t()
            &:hover
                color var(--main)
            &.active
                color var(--main)
        
        +to-width(640px)
            padding-right 30px

.stats-item
    padding 15px 20px
    border-radius 15px
    background-color #a4d0d4
    color white
    margin-right 10px

    &__title
        font-size 12px
        font-weight 500
        padding-bottom 10px
    
    &__text
        font-size 24px
        font-weight 600

.card
    position relative
    z-index 2
    background var(--blocks)
    border-radius 20px
    border 2px solid #c4eaed
    width 100%
    max-width 350px
    padding 20px
    padding-top 40px
    display flex
    flex-direction column
    align-items center
    +to-width(1200px)
        max-width 320px
    +to-width(1100px)
        max-width 360px
    
    .map-button
        padding 14px 18px
        p
            font-size 13px
        
    .button-icon
        margin 0 10px
    
    .people-offline
        top 25px
        left 20px
    
    .people-online
        top 30px
        left 20px

    &-string
        display flex
        width 100%
        margin-top 25px

    &__input
        border none
        padding 0 2px
        font-size 18px
        font-weight 600
        width inherit
        &:first-child
            text-align right
    
    &-add-sports
        margin 15px 0

    &-panel
        position absolute
        bottom 20px
        left 0
        right 0
        center()
        // transform translateY(60px)
        opacity 0
        t()
        +to-width(900px)
            // transform translateY(0)
            opacity 1
        &__item
            box-shadow 0 0 10px #333
            background-color white
            border-radius 50%
            width 30px
            height 30px
            margin 0 3px
            center()
            position relative
            cursor pointer

        &__input
            position absolute
            left 0
            top 0
            right 0
            bottom 0
            opacity 0
            width 100%
            cursor pointer
            z-index 2
    &-wrap
        width 100%
        max-width 250px
        display flex
        flex-direction column
        align-items center

    &__avatar
        width 200px
        height 200px
        border-radius 50%
        position relative
        // background #333
        background white
        background-size cover
        background-position center
        cursor pointer
        // overflow hidden
        &:hover
            .card-panel
                opacity 1
        
        &_loader
            position absolute
            left 0
            top 0
            right 0
            bottom 0
            background-color rgba(0,0,0,0.5)
            center()
            svg
                width 40px
                height 40px
                fill white
    
    &-rate
        // width 40px
        height 40px
        border-radius 40px
        border 2px solid white
        font-size 14px
        padding 0 8px
        padding-left 6px
        right 5px
        top 10px
        position absolute
        center()
        &__emoji
            font-size 22px
        p
            margin 0 3px
            color white
            font-weight 600
        img
            max-width 60%
    
    &__name
        margin-top 25px
        font-size 18px
        font-weight 600
    
    &__status
        margin-top 15px
        font-size 16px
        width 70%
        text-align center
        padding-bottom 20px
        border-bottom 1px solid #d8d8d8
        color #aeaeae
        &_input
            border 0
            margin-top 15px
            font-size 16px
            text-align center
            color #aeaeae
            padding-bottom 20px
            border-bottom 1px solid #d8d8d8
            width 70%
    
    &__text
        font-size 14px
        color black
        padding 0 30px
        padding-bottom 15px
        width 100%
    
    &-buttons
        display flex
        margin 10px 0
        
    &-button
        padding 12px 20px
        border-radius 8px
        // box-shadow: 0 0 15px #e0e0e0
        background var(--main)
        font-size: 13px
        font-weight: 600
        cursor: pointer
        color white
        -webkit-transition 0.3s
        transition: 0.3s

    .people-category
        center()
        flex-wrap wrap
        margin 20px 0
    .people-category__item
        padding 10px 20px
</style>